import createHttp from '../lib/http'

export function fetchMeAccess() {
  return createHttp.get('api/me/access').then((response) => {
    if (!response || response.status >= 400 || response.data?.status === false) {
      const error = new Error('me_access_failed')
      error.response = response
      throw error
    }
    return response.data?.data || null
  })
}

export function fetchAccessTemplates() {
  return createHttp.get('api/access/templates').then((response) => response?.data?.data || [])
}

export function fetchAccessProfiles() {
  return createHttp.get('api/access/profiles').then((response) => response?.data?.data || [])
}

export function createProfileFromTemplate(templateKey) {
  return createHttp.post('api/access/profiles/from-template', { template_key: templateKey })
}

export function createCustomProfile(name, permissions) {
  return createHttp.post('api/access/profiles', { name, permissions })
}

export function updateAccessProfile(id, body) {
  return createHttp.put(`api/access/profiles/${id}`, body)
}

export function deleteAccessProfile(id) {
  return createHttp.delete(`api/access/profiles/${id}`)
}

export function fetchEmployeeAssignment(userId) {
  return createHttp.get(`api/access/employees/${userId}/assignment`)
}

export function saveEmployeeAssignment(userId, body) {
  return createHttp.put(`api/access/employees/${userId}/assignment`, body)
}
